import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-partners-landing-page',
  templateUrl: './business-partners-landing-page.component.html',
  styleUrls: ['./business-partners-landing-page.component.scss']
})
export class BusinessPartnersLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
